/* eslint-disable */
/* tslint:disable */
/* Do not edit - generated by swagger-typescript-api */

import {
  Condition,
  ErrorResponse,
  SkuDescriptionResponseCollectionResponse,
  SkuDescriptionResponseDataResponse,
  Sorting,
} from './data-contracts';
import { HttpClient, RequestParams } from './http-client';
export class SkuDescriptions<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;
  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }
  /**
   * No description
   *
   * @tags SkuDescriptions
   * @name SkuDescriptionsList
   * @request GET:/SkuDescriptions
   * @response `200` `SkuDescriptionResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  skuDescriptionsList = (
    query?: {
      /** @format int32 */
      skip?: number;
      /** @format int32 */
      top?: number;
      inlineCount?: boolean;
      search?: string;
      sortings?: Sorting[];
      conditions?: Condition[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<SkuDescriptionResponseCollectionResponse, ErrorResponse>({
      path: `/SkuDescriptions`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags SkuDescriptions
   * @name GetSkuDescription
   * @request GET:/SkuDescriptions/{id}
   * @response `200` `SkuDescriptionResponseDataResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getSkuDescription = (id: number, params: RequestParams = {}) =>
    this.http.request<SkuDescriptionResponseDataResponse, ErrorResponse>({
      path: `/SkuDescriptions/${id}`,
      method: 'GET',
      format: 'json',
      ...params,
    });
}
